import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Box, Grid, Typography, Avatar, TextField, FormGroup, FormControlLabel, Switch } from "@mui/material";
import Select from "react-select";
import CustomStyles from "./DropdownCustomStyles";
import { axiosFetch } from "../utils/AxiosFetch";
import { configAxios } from "../utils/ConfigAxios";
import Dropzone from "react-dropzone";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import { CustomizedSnackbar } from './index';
import { useDispatch, useSelector } from "react-redux";
import { SnackbarActions } from '../redux/actions/snackbar.actions'
import { load_UserDetails } from '../redux/actions/user.actions'
import { loadJobTitle, loadReportingManagers, loadEmployeeType } from '../redux/actions/lookups.action'
import { fetchChartData2 } from '../redux/actions/structure.actions';
import { useNavigate } from "react-router";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};


function AddUserModal(props) {
  const [open, setOpen] = useState(props.openModal);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [secEmail, setSecEmail] = useState("")
  const [JoinedDate, setJoinedDate] = useState("");
  const [deptOption, setDeptOption] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [department, setDepartment] = useState("");
  const [teamOption, setTeamOption] = useState([]);
  const [team, setTeam] = useState("");
  const [jobTitleOption, setJobTitleoption] = useState([]);
  const [jobTitle, setJobTitle] = useState("");
  const [uploadImageName, setUploadImageName] = useState("");
  const [profileImageName, setProfileImageName] = useState("");
  const [departmentError, setDepartmentError] = useState(false);
  const [jobTitleError, setJobTitleError] = useState(false);
  const [multiEmailError, setMultiEmailError] = useState(false);
  const [emailErrMsg, setEmailErrMsg] = useState("");
  const [managerError, setManagerError] = useState(false);
  const [empTypeError, setEmpTypeError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = React.useState(true);
  const [managerId, setManagerId] = useState(props.reportingManagerId ? props.reportingManagerId : "");
  const [managerName, setManagerName] = useState(props.reportingManagerName ? props.reportingManagerName : "")
  const [repManager, setRepManager] = useState("");
  const [isManager, setIsManager] = useState(false);
  const [repManagerOption, setRepManagerOption] = useState([]);
  const [empTypeOption, setEmpOption] = useState([]);
  const [empType, setEmpType] = useState("")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let LUJobTitle = useSelector(state => state.loadJobTitle_Reducer.jobTitleList)
  let LUReportingManager = useSelector(state => state.loadReportingManagers_Reducer.managerList)
  let LUEmpType = useSelector(state => state.loadEmpType_Reducer.empTypeList)

  const allowedTypes = ["image/jpeg", " image/jpg", " image/png", " image/svg"];


  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };
  useEffect(() => {
    ValidatorForm.addValidationRule('isEmpty', (value) => {
      if (value.trim().length === 0) {
        return false;
      }
      return true;
    });
  }, []);

  useEffect(() => {
    if (LUEmpType !== undefined) {
      setEmpOption(LUEmpType)
    }
  }, [LUEmpType])

  useEffect(() => {
    setJobTitleoption(LUJobTitle)
  }, [LUJobTitle])

  useEffect(() => {
    setRepManagerOption(LUReportingManager)
  }, [LUReportingManager])

  useEffect(() => {
    if (props.departmentName !== undefined) {
      var selectedDeptOption = [];
      setIsSelected(true)
      if (deptOption.length > 0) {
        deptOption.map((dept) => {
          if (dept.label == props.departmentName) {
            fetchDepartmentTeamLookup(dept.value)
            selectedDeptOption.push(dept);
          }
          // handleDeptSelect(selectedDeptOption)

          setDepartment(selectedDeptOption)
          // console.log(selectedDeptOption)
        });
      }
    }
  }, [props.departmentName, deptOption])
  useEffect(() => {
    if (props.teamName !== undefined) {
      var selectedTeamOption = [];
      if (teamOption.length > 0) {
        teamOption.map((team) => {
          if (team.label === props.teamName) {
            selectedTeamOption.push(team);
          }
          setTeam(selectedTeamOption)
        })
      }
    }
  }, [teamOption])

  useEffect(() => {
    if (props.reportingManagerId !== undefined) {
      setManagerId(props.reportingManagerId)

    }
  }, [repManagerOption, props.reportingManagerId])

  useEffect(() => {
    if (props.reportingManagerName !== "") {
      setManagerName(props.reportingManagerName)
    }

  }, [props.reportingManagerName])
  useEffect(() => {
    if (props.openModal) {
      setOpen(true);
      setFirstName("");
      setLastName("");
      setEmail("");
      setSecEmail("");
      setJoinedDate("");
      setDepartment("");
      setJobTitle("");
      setRepManager("");
      setTeam("");
      setIsSelected(false);
      setMultiEmailError(false);
      setDepartmentError(false);
      setManagerError(false);
      setJobTitleError(false);
      setEmpTypeError(false);
      setUploadImageName("");
      setProfileImageName("");
      //api calls
      fetchDepartmentLookup();
      dispatch(loadJobTitle());
      dispatch(loadEmployeeType());
    }
  }, [props.openModal]);

  const fetchDepartmentLookup = () => {
    axiosFetch({
      method: "GET",
      url: "/lookup/departments",
    })
      .then((res) => {
        if (res.status === 200) {
          setDeptOption(res.data);
        }
        if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchDepartmentTeamLookup = (id) => {
    axiosFetch({
      method: "GET",
      url: `/lookup/department/teams/${id}`,
    })
      .then((res) => {
        if (res.status === 200) {
          setTeamOption(res.data);
        }
        if (res.status === 400) {

          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };


  const handleClose = () => {
    props.addUser();
    setOpen(false);
    setLoading(false)
  };

  const handleDeptSelect = (selected) => {
    var name = [];
    name.push(selected);
    setDepartmentError(false)
    setDepartment(name);
    if (name[0].value !== "") {
      var id = name[0].value;
      var req = {
        "departmentId": id,
        "teamId": 0
      }
      setRepManager("");
      setIsSelected(true);
      fetchDepartmentTeamLookup(id);
      dispatch(loadReportingManagers(req))
    }
  };

  const handleJobSelect = (selected) => {
    var name = [];
    name.push(selected);
    setJobTitle(name)
    setJobTitleError(false)
  }

  const handleEmpTypeSelect = (selected) => {
    var name = [];
    name.push(selected);
    setEmpType(name)
    setEmpTypeError(false)
  }

  const handleTeamSelect = (selected) => {
    var name = [];
    name.push(selected);
    setTeam(name);
    if (name[0].value !== "") {
      var teamId = name[0].value;
      var req = {
        "departmentId": department[0].value,
        "teamId": teamId
      }
      dispatch(loadReportingManagers(req))
    }
  };

  const handleManagerSelect = (selected) => {
    var name = [];
    name.push(selected);
    setRepManager(name);
    setManagerError(false);
  }

  const handleSubmit = () => {
    if (!firstName) {
      alert("empty")
    }
    var deptId;
    var teamId;
    var jobId;
    var empTypeId;
    var arr = [];
    if (secEmail !== "") {
      let regex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/);
      // let regex = new RegExp('[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}');
      let testEmails = secEmail.split(",")
      testEmails.forEach((address, index) => {
        if (regex.test(address)) {
          // arr.push(index)
        }
        else {
          arr.push(index + 1)
        }
      });
      if (arr.length > 0) {
        setMultiEmailError(true)
        setEmailErrMsg(`Email address ${arr.toString()} Invalid `)
      }
    }
    if (department.length > 0 && jobTitle.length > 0 && empType.length > 0) {
      var reportingMangerId;
      if (arr.length === 0) {
        deptId = department[0].value
        jobId = jobTitle[0].value
        empTypeId = empType[0].value
        if (team.length > 0) {
          teamId = parseInt(team[0].value)
        }
        if (managerId == "") {
          if (repManager.length > 0) {
            setLoading(true)
            reportingMangerId = repManager[0].value
            var req = {
              "profilePhotoName": profileImageName,
              "originalPhotoName": uploadImageName,
              "firstname": firstName,
              "lastname": lastName,
              "emailId": email,
              "joiningDate": JoinedDate,
              "jobTitleId": parseInt(jobId),
              "secondaryEmails": secEmail,
              "departmentId": parseInt(deptId),
              "teamId": teamId,
              "reportingMangerId": parseInt(reportingMangerId),
              "isManager": isManager,
              "employeeTypeId": parseInt(empTypeId)
            }
            registerUser(req)
          }
          else {
            setManagerError(true)
          }
        }
        else {
          setLoading(true)
          reportingMangerId = managerId;
          var req = {
            "profilePhotoName": profileImageName,
            "originalPhotoName": uploadImageName,
            "firstname": firstName,
            "lastname": lastName,
            "emailId": email,
            "joiningDate": JoinedDate,
            "jobTitleId": parseInt(jobId),
            "secondaryEmails": secEmail,
            "departmentId": parseInt(deptId),
            "teamId": teamId,
            "reportingMangerId": parseInt(reportingMangerId),
            "isManager": isManager,
            "employeeTypeId": parseInt(empTypeId)
          }
          registerUser(req)
        }

      }

    }
    else {
      if (department.length === 0) {
        setDepartmentError(true)
      }
      if (jobTitle.length === 0) {
        setJobTitleError(true)
      }
      if (empType.length === 0) {
        setEmpTypeError(true)
      }

    }
  };
  const registerUser = (req) => {
    axiosFetch({
      method: "POST",
      url: "/account/register",
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            var req = {
              Keyword: "",
              Alphabet: null,
              DepartmentName: "",
              JobTitle: "",
              Location: "",
              ReportingManagerId: "",
              IsActive: true,
              Page: 1,
              ResultsPerPage: 6,
            };

            dispatch(SnackbarActions(true, "success", "New user created succesfully"))
            setLoading(false)
            setOpen(false)
            if (managerId === "") {
              dispatch(load_UserDetails(req))
            }
            else {
              dispatch(fetchChartData2(managerId));
            }
          }
        }
        if (res.status === 401) {
          navigate("/");
        }
        if (res.status === 400) {
          setLoading(false);
          if(res.data === "Email address already exists"){
            dispatch(SnackbarActions(true, "error", res.data))
          }
          else{
            dispatch(SnackbarActions(true, "error", "Something went wrong"))
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const renderAcceptedFileTypes = () => {
    let typesStr = "";
    if (allowedTypes) {
      allowedTypes.forEach((type /*, index*/) => {
        typesStr += `${type}, `;
      });
    }

    return typesStr;
  };
  const uploadImage = (file) => {
    if (file && file[0]) {
      const formData = new FormData();
      formData.append("file", file[0], file[0].name);
      upload(formData);
    }
  };
  const upload = (file) => {
    configAxios
      .post("/Uploads/profile/image", file)
      .then((res) => {
        if (res.status === 200) {
          setProfileImageName(res.data.profileImageName);
          setUploadImageName(res.data.originalImageName);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCheck = (event) => {
    setIsManager(event.target.checked)
  }
  const handleSecEmail = (e) => {
    setSecEmail(e.target.value)
    setMultiEmailError(false)
  }

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth="sm"
        maxWidth="sm"
      >
        <ValidatorForm onSubmit={() => handleSubmit()} style={{ backgroundColor: "#fff" }}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            className="modal-heading"
          >
            Add User
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Box
              alignItems="center"
              display="flex"
              justifyContent="center"
              component="form"
              autoComplete="off"
            >
              <Grid container spacing={2} item xs={12} className="grid-margins">
                {uploadImageName === "" ? (
                  <Grid item xs={12}>
                    <Dropzone
                      disableClick={true}
                      onDrop={(e) => uploadImage(e)}
                      className="dropzone"
                      activeClassName="active-dropzone"
                      multiple={false}
                      accept={renderAcceptedFileTypes}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div
                            {...getRootProps()}
                            style={{
                              cursor: "pointer",
                              border: "1px solid black",
                            }}
                          >
                            <input {...getInputProps()} />
                            <p>
                              <UploadFileIcon /> Click here to Add the profile
                              picture
                            </p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Avatar
                      sx={{
                        width: 150,
                        height: 150,
                      }}
                      alt="A"
                      src={uploadImageName ? `/api/uploads/image/show/${uploadImageName}` : ''}
                    />
                  </Grid>
                )}
                <Grid item xs={12} className="grid-margins" style={{ zIndex: "10" }}>
                  <h3 className="input-head">Select Employee type<span style={{ color: "red" }}>*</span></h3>
                  <Select
                    className="department-select"
                    value={empType}
                    options={empTypeOption}
                    // styles={CustomStyles}
                    onChange={handleEmpTypeSelect}
                  />
                  {empTypeError ? <p style={{ color: "red", marginLeft: "10px" }}>This is requird field</p> : ""}
                </Grid>
                <Grid item xs={6} className="grid-margins">
                  <TextValidator
                    id="input-with-icon-textfield"
                    variant="outlined"
                    fullWidth
                    label="First Name *"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    validators={["required", "isEmpty"]}
                    errorMessages={["Please fill out this field", "Firstname should not be empty"]}
                  />
                </Grid>
                {/* <Grid item xs={4}>
                  <Typography sx={{ marginTop: 4 }}>Last Name</Typography>
                </Grid> */}
                <Grid item xs={6} className="grid-margins">
                  <TextValidator
                    id="input-with-icon-textfield"
                    variant="outlined"
                    fullWidth
                    label="LastName *"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    validators={["required", "isEmpty"]}
                    errorMessages={["Please fill out this field", "LastName should not be empty"]}
                  />
                </Grid>
                {/* <Grid item xs={4}>
                  <Typography sx={{ marginTop: 4 }}>Email</Typography>
                </Grid> */}
                <Grid item xs={6} className="grid-margins">
                  <h3 className="input-head">Official E-mail<span style={{ color: "red" }}>*</span></h3>
                  <TextValidator
                    id="input-with-icon-textfield"
                    variant="outlined"
                    fullWidth
                    label="Please Enter Your E-mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    validators={["required", "isEmail"]}
                    errorMessages={["Please fill out this field", "Enter Valid Email Id"]}
                  />
                </Grid>
                <Grid item xs={6} className="grid-margins">
                  <h3 className="input-head">Other E-mail</h3>
                  <TextValidator
                    id="input-with-icon-textfield"
                    variant="outlined"
                    fullWidth
                    label="Enter other emails with comma seperated"
                    type="email"
                    value={secEmail}
                    onChange={handleSecEmail}
                  />
                  {multiEmailError ? <p id="emailError" style={{ color: "red" }}>{emailErrMsg}</p> : ""}
                </Grid>
                {/* <Grid item xs={4}>
                  <Typography sx={{ marginTop: 3 }}>Date of Joining</Typography>
                </Grid> */}
                <Grid item xs={6} className="grid-margins">
                  <h3 className="input-head">DOJ<span style={{ color: "red" }}>*</span></h3>
                  <TextValidator
                    type="date"
                    variant="outlined"
                    fullWidth
                    value={JoinedDate}
                    onChange={(e) => setJoinedDate(e.target.value)}
                    validators={["required"]}
                    errorMessages={["Please fill out this field"]}
                  />
                </Grid>
                {/* {managerId !== ""? */}
                <Grid item xs={6}>
                  <FormGroup className="input-head" sx={{ marginTop: 3 }}>
                    <FormControlLabel control={<Switch checked={isManager} onChange={handleCheck} />} label="Create as Manager" />
                  </FormGroup>
                </Grid>
                {/* :"" */}
                <Grid item xs={6} className="grid-margins">
                  <h3 className="input-head">Select Job Title<span style={{ color: "red" }}>*</span></h3>
                  <Select
                    className="department-select"
                    value={jobTitle}
                    options={jobTitleOption}
                    // styles={CustomStyles}
                    onChange={handleJobSelect}
                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
                  {jobTitleError ? <p style={{ color: "red", marginLeft: "10px" }}>This is requird field</p> : ""}
                </Grid>


                <Grid item xs={6} className="grid-margins">
                  <h3 className="input-head">Select Department<span style={{ color: "red" }}>*</span></h3>
                  <Select
                    className="department-select"
                    value={department}
                    options={deptOption}
                    // styles={CustomStyles}
                    onChange={handleDeptSelect}
                    isDisabled={managerId === "" ? false : true}
                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
                  {departmentError ? <p style={{ color: "red", marginLeft: "10px" }}>This is requird field</p> : ""}
                </Grid>
                {isSelected ? (
                  <>
                    <Grid item xs={6} className="grid-margins">
                      <h3 className="input-head">Select Team </h3>
                      <Select
                        value={team}
                        options={teamOption}
                        // styles={CustomStyles}
                        onChange={handleTeamSelect}
                        menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      />
                    </Grid>
                    {/* {managerId === ""? */}
                    <Grid item xs={6} className="grid-margins">
                      <h3 className="input-head">Select Reporting Manager<span style={{ color: "red" }}>*</span> </h3>
                      <Select
                        value={managerId === "" ? repManager : [{ label: managerName, value: 1 }]}
                        options={repManagerOption}
                        // styles={CustomStyles}
                        onChange={handleManagerSelect}
                        menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        isDisabled={managerId === "" ? false : true}
                      />
                      {managerError ? <p style={{ color: "red", marginLeft: "10px" }}>This is requird field</p> : ""}
                    </Grid>
                    {/* :""} */}
                  </>
                ) : (
                  ""
                )}

              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button
                type="submit"
                className="theme-btn"
                variant="contained"
                sx={buttonSx}
                disabled={loading}
              // onClick={handleButtonClick}
              >
                Submit
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                  }}
                />
              )}
            </Box>
          </DialogActions>
        </ValidatorForm>
      </BootstrapDialog>
      <CustomizedSnackbar />
    </div>
  );
}
export default AddUserModal;
